import React, { useEffect } from "react";
import "./latestJobs.css";
import { Link } from "react-router-dom"; 
// import Image1 from "../../assets/driver.jpg";
// import Image2 from "../../assets/cook.jpg";
// import Image3 from "../../assets/nurse.jpg";
import Aos from "aos";
import "aos/dist/aos.css";

export default function LatestJobs() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="segment-home">
      <center>
        <div className="segment-page-container">
          <div className="segment-column text-column">
            <h2
              className="segment-h1"
              data-aos="fade-right"
              data-aos-duration="900"
            >
              Latest Job Listing
            </h2>
            <Link
              to="/vacancy"
              className="homeSeg-target_button"
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              View more
            </Link>
          </div>
          <div className="segment-column image-columns">
            <div
              className="segment-image-container"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image1} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">Bike Riders</p>
              </div>
            </div>
            <div
              className="segment-image-container"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image1} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">Building Mason</p>
              </div>
            </div>
            <div
              className="segment-image-container"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image2} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">Security and Life Guards</p>
              </div>
            </div>
            <div
              className="segment-image-container"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image3} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">Factory Workers</p>
              </div>
            </div>
            <div
              className="segment-image-container"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image3} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">E-Picker</p>
              </div>
            </div>
            <div
              className="segment-image-container"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {/* <img className="segment-image2" alt="" src={Image3} /> */}
              <div className="segment-image-p">
                <p className="segment-p3">Chinese Cook</p>
              </div>
            </div>
          </div>
        </div>
      </center>
    </div>
  );
}
